import { createAPI } from '@common'

export default {
  // 读问卷列表
  postNisPollList: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0mjtu', 'post', config),
  // 登录问卷网
  getNisPollLogin: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0mphjo', 'get', config),
  // 新建
  getNisPollCreate: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0dsfbuf', 'get', config),
  // 读问卷
  getNisPoll: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm', 'get', config),
  // 问卷设置
  postNisPoll: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm', 'post', config),
  // 浏览
  getNisPollPreview: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0qsfwjfx', 'get', config),
  // 统计
  getNisPollReport: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0sfqpsu', 'get', config),
  // 复制链接
  getNisPollLink: config => createAPI('customEncryptApiName-1/0w20ojt0qpmm0mjol', 'get', config)
}
